export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"},{"name":"generator","content":"Vue Storefront 2"}],"link":[{"rel":"preconnect","href":"https://mkmbs.bloomreach.io"},{"rel":"preconnect","href":"https://cdn11.bigcommerce.com"},{"rel":"preconnect","href":"https://www.googletagmanager.com"},{"rel":"dns-prefetch","href":"https://www.google-analytics.com"},{"rel":"dns-prefetch","href":"https://edge.fullstory.com"},{"rel":"preload","href":"/fonts/Montserrat-VariableFont_wght.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"},{"rel":"preload","href":"/fonts/AllertaStencil-Regular.woff2","as":"font","type":"font/woff2","crossorigin":"anonymous"}],"style":[],"script":[{"hid":"gtm-script","innerHTML":"(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n          new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n          j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n          'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n          })(window,document,'script','dataLayer','GTM-MDBF94NX');","type":"text/javascript","defer":true,"crossorigin":"anonymous"},{"hid":"rum-script","innerHTML":"LUX=function(){function n(){return Date.now?Date.now():+new Date}var r,e=n(),t=window.performance||{},a=t.timing||{navigationStart:(null===(r=window.LUX)||void 0===r?void 0:r.ns)||e};function o(){return t.now?(r=t.now(),Math.floor(r)):n()-a.navigationStart;var r}(LUX=window.LUX||{}).ac=[],LUX.addData=function(n,r){return LUX.cmd([\"addData\",n,r])},LUX.cmd=function(n){return LUX.ac.push(n)},LUX.getDebug=function(){return[[e,0,[]]]},LUX.init=function(){return LUX.cmd([\"init\"])},LUX.mark=function(){for(var n=[],r=0;r<arguments.length;r++)n[r]=arguments[r];if(t.mark)return t.mark.apply(t,n);var e=n[0],a=n[1]||{};void 0===a.startTime&&(a.startTime=o());LUX.cmd([\"mark\",e,a])},LUX.markLoadTime=function(){return LUX.cmd([\"markLoadTime\",o()])},LUX.measure=function(){for(var n=[],r=0;r<arguments.length;r++)n[r]=arguments[r];if(t.measure)return t.measure.apply(t,n);var e,a=n[0],i=n[1],u=n[2];e=\"object\"==typeof i?n[1]:{start:i,end:u};e.duration||e.end||(e.end=o());LUX.cmd([\"measure\",a,e])},LUX.send=function(){return LUX.cmd([\"send\"])},LUX.ns=e;var i=LUX;if(window.LUX_ae=[],window.addEventListener(\"error\",(function(n){window.LUX_ae.push(n)})),window.LUX_al=[],\"function\"==typeof PerformanceObserver&&\"function\"==typeof PerformanceLongTaskTiming){var u=new PerformanceObserver((function(n){for(var r=n.getEntries(),e=0;e<r.length;e++)window.LUX_al.push(r[e])}));try{u.observe({type:\"longtask\"})}catch(n){}}return i}();","type":"text/javascript","tagPriority":"low","tagPosition":"head"},{"hid":"rum-script-external","src":"https://cdn.speedcurve.com/js/lux.js?id=4583636956","defer":true,"crossorigin":"anonymous","tagPriority":"low","tagPosition":"head"}],"noscript":[{"hid":"gtm-noscript","innerHTML":"<iframe src=\"https://www.googletagmanager.com/ns.html?id=GTM-MDBF94NX\"\n                height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\"></iframe>"}]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false